export const number_with_9_digits = /^\d{9}$/;
export const phoneNumberRegex = /^(?:\D*\d){10}\D*$/;
export const digitOnlyRegex = /^\d*$/;
export const removeNonDigits = /\D/g;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const nonAlphaNumericRegex = /[^a-zA-Z0-9]/g;
export const nonNumericRegex = /[^0-9]/g;
export const alphaNumericRegex = /^[a-zA-Z0-9]*$/;
export const stripLeadingZeroesRegex = /^0+/;

export const formatSSN = (value: string = '') =>
  value
    .replace(removeNonDigits, '')
    .slice(0, 9)
    .replace(/(\d{3})(\d{0,2})(\d{0,4})/, (_, a, b, c) =>
      [a, b, c].filter(Boolean).join('-')
    );

export function extractEmployeeIdFromPathName(): string | null {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('employeeId');
}
